import React from 'react';
import './App.css';
import Threads from './Threads';
import Footer from './Footer';

function Library() {
  return (
    <div className="Library">
      <div className="main-content">
        <Threads />
      </div>
      <Footer />
    </div>
  );
}

export default Library;